
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'

import { HttpInitWareSku, HttpWareSkuList } from '@/service/boss/allot';

import compSearch from './search';

import { Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
    },
    data () {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpWareSkuList,
        handleChecked (selection, row) {
            // console.log(selection)
            let a = {}
            this.checkedId = selection.map(item => {
                return a = {
                    erpSku: item.sku,
                    orgWarehouseId: item.orgWarehouseId
                }
            });
        },
        handleOperates (id, type, row) {
            this.operate = {};
            switch (type) {
                case 'init':
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.virtualstore.batchinitonesku',{defaultValue:'批量初始化单仓SKU操作'}),
                        type,
                    }
                    break;
            }
        },
        async batchOpearte () {

            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'init': request = HttpInitWareSku; params = { orgId: global.SYSID, list: this.checkedId }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },

    },
    computed: {
        columns () {
            return [
                {
                    type: 'selection',
                    width: 60,
                },
                {
                    title: this.$t('global.common.project',{defaultValue:'项目'}),
                    sortable: true,
                    render: (h, { row }) => {
                        return <span>{row.lineName}</span>
                    },
                },
                {
                    title: this.$t('global.common.warehouse',{defaultValue:'仓库'}),
                    key: 'orgWarehouseCode',
                    sortable: true,
                    render: (h, { row }) => {
                        return <span>{row.orgWarehouseCode}</span>
                    },
                },
                {
                    title: 'ERPSKU',
                    key: 'sku',
                    sortable: true,
                }];
        },
    },
};




